import { ENSO_POSTER, ENSO_VIDEO, HERO_BG, LIVE_IMG } from "../campaigns";

// Single source of truth for the portfolio — used by the home
// carousel (SelectedWork), the /work archive and the service pages.
// `tags` double as service categories; service pages auto-match on them.
// Media items ending in .mp4 render as video in the project viewer.
export const PROJECTS = [
  {
    title: "ENSO × Brick Lane",
    tags: ["Projection Mapping"],
    location: "London",
    desc: "Projection mapping across the Brick Lane wall — the ENSO artwork illuminated at architectural scale after dark.",
    cover: ENSO_POSTER,
    images: [ENSO_VIDEO, HERO_BG],
  },
  {
    title: "Live Event Projection",
    tags: ["Live Event"],
    location: "London",
    desc: "A private live event transformed with large-scale projection — colour, movement and light across every surface of the room.",
    images: [LIVE_IMG.live1, LIVE_IMG.live2, LIVE_IMG.live3, LIVE_IMG.live4],
  },
];
